import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'tenant-configuration',
    component: () => import(/* webpackChunkName: "users" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'tenant-configuration-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.tenants-configuration-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "tenants-configuration-index" */ '@/modules/admin/tenants-configuration/views/Index.vue')
        },
        {
            path: 'edit/:tenant_id',
            name: 'tenant-configuration-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'tenant-configuration-edit',
                        },
                        transKey: 'breadcrumbs.tenants-configuration-index',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.tenants-configuration-detail',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "tenants-configuration-edit" */ '@/modules/admin/tenants-configuration/views/Edit.vue')
        },
    ]
}